import React from 'react'

export function ActionButtonsStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #action-button-container {
          display: flex;
          justify-content: flex-end;
          padding: 5px;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function ProductsListSettingsFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .header-caption {
          background-color: rgba(20, 150, 200, 1);
          color: whitesmoke;
          padding: 3px 10px;
          margin: 5px 0;
        }

        .form-container {
          font-size: 0.75em;
          padding: 0 10px;
          margin-bottom: 10px;
        }

        .settings-input-form {
          display: flex;
          padding-left: 10px;
        }

        .settings-input-form input, .settings-input-form select {
          flex: 2;
          font-size: 0.9em;
          font-family: arial;
          padding: 3px;
        }

        .main-wrapper {
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .main-container {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          height: 100%;
          flex: 2;
          overflow: auto;
        }
      `}
      </style>
    </React.Fragment>
  )
}
